import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProjectService } from 'src/app/service/project/service/project.service';
import { SchedulerService } from 'src/app/service/scheduler/service/scheduler.service';
import { LoginService } from '@serengeti/serengeti-common';
import { MenuService } from '@serengeti/serengeti-menu';
import { AuthServiceBase } from './auth.service.base';

@Injectable({
	providedIn: 'root'
})
export class ServiceAuthService extends AuthServiceBase {

	constructor(
		private projectService: ProjectService,
		private schedulerService: SchedulerService,
		protected router: Router,
		protected menuService: MenuService,
		protected loginService: LoginService,
		protected translateService: TranslateService
	) {
		super(router, menuService, loginService, translateService);
	}

	async canActivate(activated: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const authorized = await super.canActivate(activated, state);

		if (this.projectService.activeState) {
			if (authorized) {
				const statePath = activated.url;
				const routePath = activated.routeConfig.path.split('/');
	
				for (const [i, route] of routePath.entries()) {
					if (route === ':projectId') {
						const loginId = this.loginService.getLoginId();
						const project = await this.projectService.get(statePath[i].path).toPromise();
	
						if (!project) {
							this.translateService.get('common.invalid.access-service').subscribe((message: string) => {
								alert(message);
								this.router.navigate(['/main']);
							});
							return false;
						} else {
							if (project.ownerId === loginId) {
								return true;
							} else {
								for (const projectUser of project.users) {
									if (projectUser.user.userId === loginId && projectUser.status === 'Approved') {
										return true;
									}
								}
								this.translateService.get('common.invalid.access-service').subscribe((message: string) => {
									alert(message);
									this.router.navigate(['/main']);
								});
								return false;
							}
						}
					} else if (route === ':groupId') {
						const schedule = await this.schedulerService.get(statePath[i].path).toPromise();
	
						if (schedule.shared) {
							return true;
						} else if (schedule.ownerId === this.loginService.getLoginId()) {
							return true;
						} else {
							this.translateService.get('common.invalid.access-service').subscribe((message: string) => {
								alert(message);
								this.router.navigate(['/main']);
							});
							return false;
						}
					}
				}
				return true;
			} else {
				return false;
			}	
		} else {
			return false;
		}
	}
}
